import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AlertsContext } from "providers/alerts";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { LoansContext } from "providers/loans";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "utils/errorHandler";
import { isPermissionEnabled, permissionConstants, hasPermission } from "utils/permissionHelper";
import { useDeleteLoan } from "modules/loan/mutations/use-loan-delete";

const DeleteLoanBtn = ({ id }: { id: string }) => {
  const navigate = useNavigate();
  const { user } = useTenant();
  const { refetch: renewCache } = useContext(LoansContext);
  const { showError, showSuccess } = useContext(AlertsContext);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [readLoan, setReadLoan] = useState(false);
  const deleteLoanMutation = useDeleteLoan();

  const readOnlyLoan = () => {
    if (!hasPermission(user, permissionConstants.deleteLoan)) {
      setReadLoan(true);
    }
    if (!isPermissionEnabled(user)) {
      setReadLoan(false);
    }
  };

  useEffect(() => {
    readOnlyLoan();
  }, []);

  const deleteLoan = async () => {
    try {
      await deleteLoanMutation.mutateAsync(id);
      showSuccess({
        title: "Loan Deleted",
        description: "The loan & all associated data has now been deleted.",
      });
      renewCache();
      navigate("/loans");
    } catch (error) {
      showError({
        title: "Deletion Failed",
        description: getErrorMessage(error),
      });
    }
  };

  return (
    <Flex justifyContent="flex-end">
      <Button
        onClick={onOpen}
        variant="secondary"
        borderWidth="0px"
        isDisabled={readLoan}
        leftIcon={<FontAwesomeIcon icon={["far", "trash-alt"]} />}
        _hover={{
          color: "red",
        }}
      >
        Delete Loan
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Loan</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Are you sure you want to delete this loan, and all data associated with it?</Text>
          </ModalBody>
          <ModalFooter>
            <Button variant="outline" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button isLoading={deleteLoanMutation.isPending} onClick={deleteLoan}>
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default DeleteLoanBtn;
